/*
 * TAKEDA CONFIDENTIAL – Highly Restricted: Do not distribute without prior approval
 *
 * © Copyright (2025) Takeda. All Rights Reserved
 */

import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { iterateTimes } from '../../../domain/shared.domain';
import { IconImage } from '../../images/images.constants';
import { getImageUrl } from '../../images/images.domain';
import { VdzPrescribingInformationLink } from './prescribing-information-link.component';

export const VdzPrescribingInformation = () => {
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);

  const isExternal = t(`${keyPrefix}.embedded`) !== 'true';
  const isDropdown = i18n.exists(`${keyPrefix}.href1`);

  const links = useMemo(
    () =>
      isDropdown
        ? iterateTimes(maxLinkCount, (index) => {
            const isDefined = i18n.exists(`${keyPrefix}.href${index + 1}`);
            return isDefined ? (
              <VdzPrescribingInformationLink
                index={index}
                isExternal={isExternal}
                extraClassNames="px-6 sm:!py-3 justify-center min-h-7 hover:underline"
                key={index}
              />
            ) : null;
          })
        : null,
    []
  );

  return isDropdown ? (
    <div
      className="relative"
      onClick={() => setOpen(!open)}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <p className="flex items-center min-h-9 sm:min-h-0 sm:py-8 text-md xl:text-xl text-center cursor-pointer select-none">
        {t('footer.vdz_indication_and_pi.title')}
        <img
          alt="arrow-icon"
          className={`sm:hidden px-1 ${open ? 'rotate-180' : ''}`}
          src={getImageUrl(IconImage.ArrowDownWhite)}
        />
      </p>

      <div
        className={`sm:absolute sm:-right-4 sm:w-[calc(100%+2rem)] z-10 overflow-hidden sm:bg-entyvio-purple rounded-b-3xl ${
          open ? '' : 'h-0'
        }`}
      >
        {links}
      </div>
    </div>
  ) : (
    <VdzPrescribingInformationLink isExternal={isExternal} />
  );
};

const keyPrefix = 'footer.vdz_indication_and_pi';
const maxLinkCount = 5;
